export const SET_ID = (state, value) => {
  state.id = value
}

export const SET_VENDORCODE = (state, value) => {
  state.vendor = value
}

export const SET_PAYERCODE = (state, value) => {
  state.payer = value
}

export const SET_DESCRIPTION = (state, value) => {
  state.description = value
}

export const SET_PRICEBATCH = (state, value) => {
  if (value && !isNaN(value)) {
    value = parseFloat(value)
  }
  state.totalAmount = value
}

export const SET_UNIT = (state, value) => {
  state.unit = value
}

export const SET_BATCHUNITS = (state, value) => {
  if (value && !isNaN(value)) {
    value = parseFloat(value)
  }
  state.count = value
}

export const SET_FROM_CATALOG = (state, value) => {
  state.isCatalog = value
}
